<template>
  <svg
    id="Group_17245"
    data-name="Group 17245"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="21"
    viewBox="-3 -2 33 25"
  >
    <rect
      id="Rectangle_961"
      data-name="Rectangle 961"
      width="2"
      height="3"
      transform="translate(8 9)"
    />
    <rect
      id="Rectangle_962"
      data-name="Rectangle 962"
      width="2"
      height="3"
      transform="translate(18 9)"
    />
    <path
      id="Path_8596"
      data-name="Path 8596"
      d="M26,4H19V2a2,2,0,0,0-2-2H11A2,2,0,0,0,9,2V4H2A2,2,0,0,0,0,6V9a1,1,0,0,0,1,1H7V9A1,1,0,0,1,8,8h2a1,1,0,0,1,1,1v1h6V9a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v1h6a1,1,0,0,0,1-1V6A2,2,0,0,0,26,4ZM17,4H11V2h6Z"
    />
    <path
      id="Path_8597"
      data-name="Path 8597"
      d="M21,11v1a1,1,0,0,1-1,1H18a1,1,0,0,1-1-1V11H11v1a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V11H1v8a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V11Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ToolboxIcon',
};
</script>
